import ApiClient from './ApiClient';

class PrizesClient {
  constructor(authToken, eventId) {
    this.apiClient = new ApiClient();
    this.gatewayUri = 'api/v1';
    this.latestVersion = 'v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.eventId = eventId;
    this.headers = {
      Authorization: `Bearer ${authToken}`,
    };
    this.params = {};
  }

  getPrizes() {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/prizes`, this.params, this.headers)
      .then((response) => response.data);
  }

  updatePrizeOrder(prizes) {
    return this.apiClient.put(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/prizes/order`, prizes, this.headers)
      .then((response) => response.data);
  }

  addPrizes(prizes) {
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/prizes`, prizes, this.headers);
  }
}
export default PrizesClient;
